<template>
  <ModalDialog
    :show-dialog="isShow"
    title="応募を取り下げますか？"
    title-class="text-lg"
    close-text="キャンセル"
    close-text-border-class="border"
    close-text-color-class="text-gray-92"
    close-text-bg-class="bg-white"
    ok-text="応募を取り下げる"
    ok-text-color-class="text-white"
    ok-text-bg-class="bg-coral-main"
    @ok-action="handleOk()"
    @close-dialog="handleCancel()"
  >
  </ModalDialog>
</template>
<script>
import ModalDialog from '@/components/modalDialog';
export default {
  components: { ModalDialog },
  emits: ['ok', 'cancel'],
  props: {
    isShow: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const handleOk = () => {
      emit('ok');
    };
    const handleCancel = () => {
      emit('cancel');
    };
    return {
      handleOk,
      handleCancel,
    };
  },
};
</script>

<style lang="scss" scoped></style>
